<template>
  <section>
    <!-- FIRST SECTION -->
    <div style="background-color: #f6f6f6" class="padding-hero hero-gradient">
      <v-row class="align-center d-flex px-12 px-md-16">
        <v-col cols="12" sm="12" md="6" lg="5" class="pa-0 pl-3">
          <div>
            <h3 class="text-color text-left titulo text-center text-md-start" style="line-height: 1.2">
              El empleo de
            </h3>
          </div>
          <div>
            <h3 class="text-color text-left titulo text-center text-md-start" style="line-height: 1.2">
              tus sueños
            </h3>
          </div>
          <p class="text-color parrafo text-left text-center text-md-start" style="line-height: 2;">¡A un clic de
            distancia!</p>
          <v-row class="d-flex justify-center justify-md-start mt-md-12">
            <v-col cols="4">
              <v-btn class="text-none white--text" :x-large="$vuetify.breakpoint.mdAndUp" block color="#22234a"
                v-if="token == null" rounded @click="login()" style="max-width: 220px;">
                Iniciar sesión
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="7" class="pa-0 align-self-end margin_top_custom">
          <v-img src="../../assets/img/ImagenLandingBolsaEmpleo.svg" class="mx-auto" :style="imgDimension" />
        </v-col>
      </v-row>
    </div>

    <ChatComponent />

    <!-- SECOND SECTION -->
    <v-row class="mt-12">
      <v-col cols="12" sm="12" md="12" order="2" order-sm="1">
        <v-row class="px-12 px-md-16 d-flex">
          <v-col v-for="(item, index) in items" :key="index" cols="12" sm="6" md="4" lg="4">
            <v-hover v-slot="{ hover }">
              <v-card rounded="lg" @click="filtrarArea(item.nombre)" class="degradado_card">
                <v-img :src="item.imagen" position="background-position" height="300px" class="cuadro">
                  <div class="degradado_overlay" :class="{ 'degradado_active': hover }"></div>
                  <v-card-text>
                    <div class="d-flex justify-center align-center">
                      <div v-if="hover" class="text-position" style="font-size: 2em; font-weight: bold">
                        <span class="texto-blanco-intenso">{{
                          item.nombre
                        }}</span>
                      </div>
                    </div>
                  </v-card-text>
                </v-img>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" sm="12" md="12" class="d-flex justify-center">
        <div>
          <h3 class="pb-0 mb-4 mt-4 mt-md-0 text-center text-md-center sub_titulo"
            style="color: #1c1e4d; font-weight: 900">
            Áreas de interés
          </h3>
          <div class="d-flex justify-center">
            <div :style="wParrafo">
              <p class="pt-0 parrafo_areas_interes text-center text-md-center"
                style="word-break: break-word; color: #616161;">
                Si estás buscando trabajo ¡El Sistema Nacional de Recursos Humanos es
                tu aliado!
                Muchas ofertas de empleo están esperándote
              </p>
            </div>
          </div>
        </div>
      </v-col>
      <h1></h1>
    </v-row>

    <v-row>
      <v-col cols="12" class="d-flex justify-center">
        <div class="text-center text-md-start mt-12">
          <v-btn class="font-weight-bold text-none btn_explorar_empleos" color="#22234a" x-large outlined rounded
            :to="{ path: '/oferta-empleos' }">
            Explorar empleos <v-icon class="ml-5">mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <ModalRegistrarmeComponent :modal="modalRegistro" @cerrar="cerrar()" />

  </section>
</template>

<script>
import { mapState } from "vuex";
import AppFooter from "../../components/AppFooter.vue";
import ChatComponent from "../../components/ChatComponent.vue";
import ModalRegistrarmeComponent from "./components/modalRegistrarmeComponent.vue";
import imagenUnoInformatica from "../../assets/img/imagenUnoInformática.jpg";
import imagenDosSalud from "../../assets/img/imagenDosSalud.png";
import imagenTresVentas from "../../assets/img/imagenTresVentas.jpg";
import imagenCuatroCallCenter from "../../assets/img/imagenCuatroCallCenter.png";
import imagenCincoConstruccion from "../../assets/img/imagenCincoConstruccion.png";
import imagenSeisFinanzas from "../../assets/img/imagenSeisFinanzas.jpg";

export default {
  data: () => ({
    REDIRECT_URL: process.env.VUE_APP_ID_REDIRECT_URL,
    BASE_URL_ID: process.env.VUE_APP_IDENTIDAD_DIGITAL_URL,
    CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
    transparent: "rgba(255, 255 ,255 ,0)",
    modalRegistro: false,
    items: [
      {
        nombre: "Informática",
        imagen:
          imagenUnoInformatica
      },
      {
        nombre: "Salud",
        imagen:
          imagenDosSalud
      },
      {
        nombre: "Ventas",
        imagen:
          imagenTresVentas
      },
      {
        nombre: "Call Center",
        imagen:
          imagenCuatroCallCenter
      },
      {
        nombre: "Construcción",
        imagen:
          imagenCincoConstruccion
      },
      {
        nombre: "Finanzas",
        imagen:
          imagenSeisFinanzas
      }
    ]
  }),

  components: {
    ModalRegistrarmeComponent,
    AppFooter,
    ChatComponent
  },

  methods: {
    filtrarArea(nombre) {
      if (nombre) {
        this.$router.push({
          path: "/oferta-empleos",
          query: { area: nombre }
        });
      }
    },

    login() {
      this.$router.push("login");
    },
    async abrirRegistrarme() {
      const url = `${this.BASE_URL_ID
        }/oauth/authorize?response_type=code&client_id=${this.CLIENT_ID
        }&redirect_uri=${this.REDIRECT_URL.replace("/", "%2F")}`;

      window.open(url, "_parent");
    },

    cerrar() {
      this.modalRegistro = false;
    }
  },

  computed: {
    ...mapState(["token"]),
    imgDimension() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        return "width: 618px; height: 556px;"
      }
    },
    wParrafo() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        return "width: 70%"
      }
      return "width: 100%"
    }
  }
};
</script>

<style scoped>
/* .bolder-text {
  -webkit-font-smoothing: antialiased;
  text-shadow: 0.2px 0 0 currentColor, -0.2px 0 0 currentColor;

} */
 .hero-gradient{
  background: linear-gradient(
    90deg,
    #F6F6F6 0%,
    #F6F6F6 50%,
    #DBDBDB 100%
  );
}
.degradado_overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.degradado_active {
  opacity: 1;
  background: linear-gradient(to bottom, rgba(9, 30, 64, 0) 0%, #091E40 100%);
}

.btn_explorar_empleos:hover {
  background-color: #22234a !important;
  color: #fff !important;
}

.text-color {
  color: #22234a !important;
}

.container-header {
  top: 0 !important;
  width: 100%;
  background-position-y: 54px;
}

.show-name {
  color: rgba(255, 255, 255, 1) !important;
}

.text-position {
  position: absolute;
  top: 80%;
  left: 10%;
  /*transform: translate(-50%, -50%);*/
  font-size: 30px;
  color: white;
}

.cuadro {
  border-radius: 25px;
}

.texto-blanco-intenso {
  color: #fff !important;
  opacity: 1 !important;
  /* removed heavy text-shadow for cleaner look */
}

/* New styles for area cards */
.area-card {
  overflow: hidden;
  /* ensure overlay & image stay clipped to rounded corners */
  border-radius: 16px;
  position: relative;
}

.area-card .v-image__image {
  border-radius: 16px;
}


.overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 55%;
  background: linear-gradient(0deg, rgba(15, 29, 63, 0.95) 0%, rgba(15, 29, 63, 0) 100%);
  opacity: 0;
  transition: opacity 220ms ease, transform 220ms ease;
  pointer-events: none;
}

.overlay-visible {
  opacity: 1;
}

.title-bottom {
  position: absolute;
  left: 20px;
  bottom: 18px;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 700;
  font-size: 1.25rem;
  z-index: 5;
  transition: transform 220ms ease, opacity 220ms ease;
  opacity: 0;
  transform: translateY(8px);
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

.area-card .title-bottom {
  transform: translateY(0);
  opacity: 1;
}

.titulo {
  font-size: 72px;
  -webkit-font-smoothing: antialiased;
  text-shadow: 0.2px 0 0 currentColor, -0.2px 0 0 currentColor;
}

.sub_titulo {
  font-size: 60px;
  -webkit-font-smoothing: antialiased;
  text-shadow: 0.2px 0 0 currentColor, -0.2px 0 0 currentColor;
}

.parrafo {
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.6rem;
  letter-spacing: 0.0125em;
}
.parrafo_areas_interes{
  font-size: 24px;
    font-weight: 500;
    line-height: 1.6rem;
    letter-spacing: 0.0125em;
}


.margin_top_custom {
  margin-top: 100px !important;
}

@media (min-width: 279px) {
  .titulo {
    font-size: 2em;
    -webkit-font-smoothing: antialiased;
    text-shadow: 0.2px 0 0 currentColor, -0.2px 0 0 currentColor;
  }

  .parrafo {
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 1.333rem;
    letter-spacing: normal;
  }

  .parrafo_areas_interes {
    font-size: 2em;
    font-weight: 500;
    line-height: 1.6rem;
    letter-spacing: 0.0125em;
  }
  .sub_titulo {
  font-size: 2em;
  -webkit-font-smoothing: antialiased;
  text-shadow: 0.2px 0 0 currentColor, -0.2px 0 0 currentColor;
}

  .margin_top_custom_title {
    margin-top: 100px;
  }

  .margin_top_custom {
    margin-top: 10px;
  }
}

@media (min-width: 600px) {
  .titulo {
    font-size: 2em;
    -webkit-font-smoothing: antialiased;
    text-shadow: 0.2px 0 0 currentColor, -0.2px 0 0 currentColor;
  }

  .parrafo {
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 1.333rem;
    letter-spacing: normal;
  }

  .sub_titulo {
  font-size: 2em;
  -webkit-font-smoothing: antialiased;
  text-shadow: 0.2px 0 0 currentColor, -0.2px 0 0 currentColor;
}
  .margin_top_custom_title {
    margin-top: 100px;
  }

  .margin_top_custom {
    margin-top: 10px;
  }
  .parrafo_areas_interes {
    font-size: 1em;
    font-weight: 500;
    line-height: 1.6rem;
    letter-spacing: 0.0125em;
  }
}

@media (min-width: 900px) {
  .titulo {
    font-size: 2.5em;
    -webkit-font-smoothing: antialiased;
    text-shadow: 0.2px 0 0 currentColor, -0.2px 0 0 currentColor;
  }
  .sub_titulo {
  font-size: 60px;
  -webkit-font-smoothing: antialiased;
  text-shadow: 0.2px 0 0 currentColor, -0.2px 0 0 currentColor;
}
  .parrafo {
    font-size: 2.125rem;
    font-weight: 400;
    line-height: 1.175;
    letter-spacing: 0.0073529412em;
  }

  .margin_top_custom_title {
    margin-top: 100px;
  }

  .margin_top_custom {
    margin-top: 10px;
  }
  .parrafo_areas_interes {
    font-size: 24px;
    font-weight: 500;
    line-height: 1.6rem;
    letter-spacing: 0.0125em;
  }
}


@media (min-width: 1320px) {
  .titulo {
    font-size: 72px;
    -webkit-font-smoothing: antialiased;
    text-shadow: 0.2px 0 0 currentColor, -0.2px 0 0 currentColor;
  }

  .margin_top_custom_title {
    margin-top: 0px;
  }

  .margin_top_custom {
    margin-top: 10px;
  }
  .parrafo_areas_interes {
    font-size: 24px;
    font-weight: 500;
    line-height: 1.6rem;
    letter-spacing: 0.0125em;
  }
}

@media (min-width: 1500px) {
  .titulo {
    font-size: 72px;
    -webkit-font-smoothing: antialiased;
    text-shadow: 0.2px 0 0 currentColor, -0.2px 0 0 currentColor;
  }

  .margin_top_custom_title {
    margin-top: 0px;
  }

  .margin_top_custom {
    margin-top: 10px;
  }
}
.padding-hero {
  padding-top: 6rem;
}
.parrafo_areas_interes {
    font-size: 24px;
    font-weight: 500;
    line-height: 1.6rem;
    letter-spacing: 0.0125em;
  }
@media screen and (max-width: 800px) {
  .padding-hero {
    padding-top: 4rem;
  }
}

@media screen and (max-width: 460px) {
  .padding-hero {
    padding-top: 6rem;
  }
}
.padding-hero {
  padding-top: 6rem;
}

@media screen and (max-width: 800px) {
  .padding-hero {
    padding-top: 4rem;
  }
}

@media screen and (max-width: 460px) {
  .padding-hero {
    padding-top: 6rem;
  }
}
</style>
